// extracted by mini-css-extract-plugin
export default {"statusSelect":"Medication_statusSelect__C3aow","selectContainer":"Medication_selectContainer__IPdGJ","left":"Medication_left__ozu1v"};